// Light rays near a black hole, from the widget: the ray's bend uses the Schwarzschild
// photon equation in the widget's units (horizon radius rs, impact parameter b). A ray that
// crosses rs is captured; one that gets far away escaped. Pure so the capture edge can be found
// headlessly and tested.

export interface Ray { x: number; y: number; vx: number; vy: number; h2: number; st: 0 | 1 | 2; tr: [number, number][]; b: number }

export const DT = 0.0016;

export function makeRay(b: number): Ray { return { x: -1.25, y: b, vx: 1, vy: 0, h2: b * b, st: 0, tr: [[-1.25, b]], b }; }

export function stepRay(r: Ray, rs: number, dt = DT) {
  const d2 = r.x * r.x + r.y * r.y, f = -1.5 * rs * r.h2 / (d2 * d2 * Math.sqrt(d2));
  r.vx += f * r.x * dt; r.vy += f * r.y * dt; r.x += r.vx * dt; r.y += r.vy * dt;
  const n = r.x * r.x + r.y * r.y;
  if (n < rs * rs) r.st = 1; else if (n > 3) r.st = 2;
}

/** run a ray to its end; true when it escapes */
export function escapes(b: number, rs: number): boolean {
  const r = makeRay(Math.abs(b));
  for (let i = 0; i < 60000 && !r.st; i++) stepRay(r, rs);
  return r.st === 2;
}

/** the smallest aim (impact parameter) that still escapes, by bisection on the real sim */
export function captureEdge(rs: number): number {
  let lo = 0, hi = 0.9;
  if (!escapes(hi, rs)) return hi;
  for (let i = 0; i < 18; i++) { const mid = (lo + hi) / 2; if (escapes(mid, rs)) hi = mid; else lo = mid; }
  return hi;
}

export function rsFor(massSlider: number): number { return 0.05 + 0.15 * massSlider / 100; }
